"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f55354 = void 0;
exports.f55354 = {
    "𞤨𞤵𞤤𞤢𞤪": [
        2353,
        2354,
        2355,
        2356,
        2357,
        2358,
        2359,
        2360,
        2361,
        2362,
        2363,
        2364
    ]
};
